import { useContext } from '../../../@rc-component/context/es/context.js';
import '../../../rc-util/es/ref.js';
import 'react';
import TableContext from '../context/TableContext.js';

/** Check if cell is in hover range */
function inHoverRange(cellStartRow, cellRowSpan, startRow, endRow) {
  var cellEndRow = cellStartRow + cellRowSpan - 1;
  return cellStartRow <= endRow && cellEndRow >= startRow;
}
function useHoverState(rowIndex, rowSpan) {
  return useContext(TableContext, function (ctx) {
    var hovering = inHoverRange(rowIndex, rowSpan || 1, ctx.hoverStartRow, ctx.hoverEndRow);
    return [hovering, ctx.onHover];
  });
}
export { useHoverState as default };
//# sourceMappingURL=useHoverState.js.map
